import { CAMCFundFOFHandler } from "_fil_local_addon/camc-fund-detail-app/camc-fund-detail-app";
import { CAMCFundFOF } from "./camc-fund-fof";

class WebsiteFundFOF extends CAMCFundFOF {
    constructor(fundCode, reportTime) {
        super(fundCode, reportTime);
        this.$root = $(".tabs-content-amc.fof");
    }

    setEmptyMessage(target = "#fof-container", emptyMessage = "暂无数据显示") {
        let $targetObj = this.$root.find(target);
        if ($targetObj) {
            $targetObj.empty();
            $targetObj.append(`<div class="api-messaging-content grid-x align-center-middle">${emptyMessage}</div>`);
        }
    }

    errorHandler() {
        showApiMessageing(null);
        this.setEmptyMessage("#fof-container");
    }

    updateFundDate(date) {
        this.$root.find(".container-updatetime-portfolio").text("数据截止日期：" + date);
    }

    generateFOFTable(FOFDataArray) {
        var $legend = this.$root.find("#fof-container-table").empty();
        if ($legend.length && FOFDataArray.length) {
            $legend.find(".tabs-content-amc__table").removeClass("hide");
            let headerItem = `
                <div class="grid-x item-title">
                    <div class="cell small-2 large-3 series">序号</div>
                    <div class="cell small-2 medium-3 series series__title">基金代码</div>
                    <div class="cell small-2 large-3 series series__title">基金名称</div>
                    <div class="cell small-4 series series__title--mobile">基金名称/代码</div>
                    <div class="cell small-2 medium-4 large-3 series series__percent">占基金资产净值比例</div>
                </div>
            `;
            $legend.append(headerItem);
            const $FOFDataArray = FOFDataArray;
            $FOFDataArray.forEach(function (element, index) {
                let contentItem = `
                    <div class="grid-x item">
                            <div class="cell small-2 large-3 series">${index + 1}</div>
                            <div class="cell small-2 medium-3 series series__item">${
                                element.securitiesCode || "-"
                            }</div>
                            <div class="cell small-6 medium-5 large-3 series series__item">${element.name}</div>
                            <div class="cell small-8 series series__item--mobile">
                                <div class="complex__item">${element.name}</div>
                                <div class="complex__item">${element.securitiesCode || "-"}</div>
                            </div>
                            <div class="cell small-2 large-3 series series__item--percent text-right">
                                ${Highcharts.numberFormat(element.fundWt).replace(",", " ")}%
                            </div>
                    </div>
                `;
                $legend.append(contentItem);
            });
        } else {
            $legend.remove();
            if (this.reportTime) {
                this.setEmptyMessage(".empty-message", "<span>本基金本期报告内</span><span>未持有基金</span>");
            } else {
                this.setEmptyMessage(".empty-message");
            }
        }
    }
}

$(async function () {
    if (window.fundCode && $(".fund-portfolio-div .fof").length) {
        const isfof = await CAMCFundFOFHandler.getIsFOF();
        if (isfof) {
            $(".fil-tabs").find("li#tab-fof").removeClass("hide");
            const camcFundFOF = new WebsiteFundFOF(window.fundCode, reportTime);
            camcFundFOF.render();
        } else {
            $(".fil-tabs").find("li#tab-fof").remove();
        }
    }
});
